import { render, staticRenderFns } from "./Wp_tabbar.vue?vue&type=template&id=5142fea8&scoped=true&"
import script from "./Wp_tabbar.vue?vue&type=script&lang=js&"
export * from "./Wp_tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142fea8",
  null
  
)

export default component.exports